import React, { Component } from 'react';
import Button from "react-md/lib/Buttons";

class MainLinks extends Component {
    getLinkElements() {
        const { mainLinks } = this.props.config;
        const { labeled } = this.props;
        return mainLinks.map(link =>
        <Button
            icon={!labeled}
            flat={labeled}
            secondary
            key={link.label}
            iconClassName={link.iconClassName}
            href={link.url}
        >
            {labeled ? link.label : ""}
        </Button>
        );
    }
    render() {
        const { mainLinks } = this.props.config;
        if (!mainLinks) {
        return null;
        }
        return (
        <div className="user-links main-links">
            {this.getLinkElements()}
        </div>
        );
    }
}

export default MainLinks;


// WEBPACK FOOTER //
// ./src/components/MainLinks/index.jsx